// extracted by mini-css-extract-plugin
export default {"skill-box":"SkillBox_skill-box__OjQ3q","skill-talk-box":"SkillBox_skill-talk-box__5PLjB","img-box":"SkillBox_img-box__fnMXI"};